import * as types from '~/store/mutation-types'
import { CACHE_CONTROL_7_DAYS_CDN_CACHE } from '~/utils/enums/caching'
import { pathOr } from 'ramda'
import api from '~/utils/api'

export const state = () => ({
  isPageNavigationInProgress: false,
  windowWidth: 0,
  windowHeight: 0,
  mobileBottomPadding: 0,
  scrollTop: 0,
  stayConnected: null,
  userAgent: null,
  userAgentDetails: null,
  isCurrentUserBot: false,
  isScrollbarHidden: false,
  previousScrollTop: 0,
  scrollTopOnHideScroll: 0,
  isScrollInProgress: false,
  isPageLoaded: false,
  isIPhone: false,
  isSafari: false
})

export const getters = {
  isPageNavigationInProgress: state => state.isPageNavigationInProgress,
  windowWidth(state) {
    return state.windowWidth
  },
  windowHeight(state) {
    return state.windowHeight
  },
  isAppleBrowser(state) {
    return state.isIPhone || state.isSafari
  },
  stayConnected(state) {
    const list = state.stayConnected
    return pathOr([], ['Channels'], list)
  },
  isIPhone(state) {
    return state.isIPhone
  },
  isSafari(state) {
    return state.isSafari
  },
  scrollTopOnHideScroll: state => state.scrollTopOnHideScroll,
  isScrollbarHidden: state => state.isScrollbarHidden,
  isScrollInProgress: state => state.isScrollInProgress,
  mobileBottomPadding(state) {
    return state.mobileBottomPadding
  },
  scrollTop: state => state.scrollTop,
  previousScrollTop: state => state.previousScrollTop,
  isPageLoaded: state => state.isPageLoaded
}

export const actions = {
  async nuxtServerInit({ dispatch }, { res }) {
    const requestStayConnected = async () => {
      try {
        await dispatch('requestStayConnected')
      } catch (err) {
        console.log(err)
      }
    }

    res.setHeader('Cache-Control', CACHE_CONTROL_7_DAYS_CDN_CACHE)

    await requestStayConnected()
  },
  setWindowWidth({ commit }, windowWidth) {
    commit(types.SET_WINDOW_WIDTH, windowWidth)
  },
  setWindowHeight({ commit }, WindowHeight) {
    commit(types.SET_WINDOW_HEIGHT, WindowHeight)
  },
  setMobileBottomPadding({ commit }, mobileBottomPadding) {
    commit(types.SET_MOBILE_BOTTOM_PADDING, mobileBottomPadding)
  },
  setScrollTop({ commit }, top) {
    commit(types.SET_SCROLL_TOP, top)
  },
  setScrollInProgressState({ commit }, value) {
    commit(types.SET_SCROLL_IN_PROGRESS_STATE, value)
  },
  setPageLoaded({ commit }, status) {
    commit(types.SET_PAGE_LOADING_STATUS, status)
  },
  async requestStayConnected({ commit }) {
    try {
      const { data } = await this.$fmAxios.get(api.layout.getStayConnected())

      commit(types.SET_STAY_CONNECTED, data)
      return data
    } catch (err) {
      throw err
    }
  }
}

export const mutations = {
  [types.SET_PAGE_NAVIGATION_IN_PROGRESS_STATE](state, value) {
    state.isPageNavigationInProgress = value
  },
  [types.SET_WINDOW_WIDTH](state, windowWidth) {
    state.windowWidth = windowWidth
  },
  [types.SET_WINDOW_HEIGHT](state, windowHeight) {
    state.windowHeight = windowHeight
  },
  [types.SET_IS_SCROLLBAR_HIDDEN](state, isScrollbarHidden) {
    state.isScrollbarHidden = isScrollbarHidden
  },
  [types.SET_MOBILE_BOTTOM_PADDING](state, mobileBottomPadding) {
    state.mobileBottomPadding = mobileBottomPadding
  },
  [types.SET_SCROLL_TOP](state, top) {
    state.previousScrollTop = state.scrollTop
    state.scrollTop = top
  },
  [types.SET_IS_CURRENT_USER_BOT](state, value) {
    state.isCurrentUserBot = value
  },
  [types.SET_USER_AGENT_DETAILS](state, value) {
    state.userAgentDetails = value
  },
  [types.SET_USER_AGENT](state, userAgent) {
    state.userAgent = userAgent || ''
  },
  [types.SET_INITIAL_DEVICE](state, { isIPhoneDevice, isSafariBrowser }) {
    state.isIPhone = isIPhoneDevice
    state.isSafari = isSafariBrowser
  },
  [types.SET_SCROLL_IN_PROGRESS_STATE](state, value) {
    state.isScrollInProgress = value
  },
  [types.SET_PAGE_LOADING_STATUS](state, status) {
    state.isPageLoaded = status
  },
  [types.SET_SCROLL_TOP_ON_HIDE_SCROLL](state, value) {
    state.scrollTopOnHideScroll = value
  },
  [types.SET_STAY_CONNECTED](state, data) {
    state.stayConnected = data
  }
}
